export default function Confirmation({ userInfo }) {
  return (
    <div className="text-center space-y-4 text-black">
      <h2 className="text-3xl font-bold" style={{ color: '#95c11f' }}>
        Pagamento riuscito!
      </h2>
      <p>
        Grazie, {userInfo.name} {userInfo.surname}
      </p>
      <p>
        Riceverai una conferma all'indirizzo: <strong>{userInfo.email}</strong>
      </p>
    </div>
  );
}
